import M from 'materialize-css'

const COLLAPSIBLE_CLASS = '.collapsible'

const Collapsible = () => {
	const init = () => {
		M.Collapsible.init(document.querySelectorAll(COLLAPSIBLE_CLASS))
	}

	return {
		init,
	}
}

export default Collapsible
